import { Box, IconButton, Typography } from '@mui/joy';
import { FC } from 'react';
import { MdClose } from 'react-icons/md';
import { Outlet, useNavigate } from 'react-router-dom';

import {
  ClinicalModeHeaderRegistryContext,
  useClinicalModeHeaderRegistry,
} from '@MP/shared/clinical/modeHeader';
import { clinicalTokens } from '@MP/shared/clinical/ui';
import FeedSocketProvider from '@MP/shared/providers/FeedSocketProvider';
import PatientProvider from '@MP/shared/providers/PatientProvider';

const DEFAULT_TITLE = '임상가 평가 모드';
const HEADER_HEIGHT = 80;

const ClinicalModeLayout: FC = () => {
  const navigate = useNavigate();
  const { registry, header } = useClinicalModeHeaderRegistry();
  const { title = DEFAULT_TITLE, actions, onClose } = header;
  const handleClose = onClose ?? (() => navigate('/patient/survey', { replace: true }));

  return (
    <FeedSocketProvider>
      <PatientProvider>
        <ClinicalModeHeaderRegistryContext.Provider value={registry}>
          <Box sx={{ minHeight: '100vh', backgroundColor: clinicalTokens.surface }}>
            <Box
              component="header"
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr auto 1fr',
                alignItems: 'center',
                height: HEADER_HEIGHT,
                px: '24px',
                borderBottom: `1px solid ${clinicalTokens.tableBorder}`,
              }}>
              <span />
              <Typography
                component="h1"
                sx={{
                  fontSize: clinicalTokens.fontSize.heading,
                  fontWeight: 700,
                  color: clinicalTokens.text,
                }}>
                {title}
              </Typography>
              <Box sx={{ justifySelf: 'end', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {actions ?? (
                  <IconButton
                    aria-label="닫기"
                    variant="plain"
                    color="neutral"
                    onClick={handleClose}
                    sx={{ width: HEADER_HEIGHT, height: HEADER_HEIGHT, mr: '-24px', borderRadius: 0 }}>
                    <MdClose size={24} color={clinicalTokens.text} />
                  </IconButton>
                )}
              </Box>
            </Box>
            <Box component="main">
              <Outlet />
            </Box>
          </Box>
        </ClinicalModeHeaderRegistryContext.Provider>
      </PatientProvider>
    </FeedSocketProvider>
  );
};

export { ClinicalModeLayout };
